import {
    FORGOT_PASSWORD,
    FORGOT_PASSWORD_SUCCESS,
    FORGOT_PASSWORD_FAILED,
    FORGOT_PASSWORD_VERIFY_OTP,
    FORGOT_PASSWORD_VERIFY_OTP_SUCCESS,
    FORGOT_PASSWORD_VERIFY_OTP_FAILED,
    RESET_PASSWORD,
    RESET_PASSWORD_SUCCESS,
    RESET_PASSWORD_FAILED,
    CANCEL_FORGOT_PASSWORD,
} from '../constants/ActionTypes'

export const forgot_password = (payload) => {
    return {
        type: FORGOT_PASSWORD,
        payload
    }
}

export const forgot_password_success = (payload) => {
    return {
        type: FORGOT_PASSWORD_SUCCESS,
        payload
    }
}

export const forgot_password_failed = (error) => {
    return {
        type: FORGOT_PASSWORD_FAILED,
        payload: error
    }
}

export const forgot_password_verify_otp = (payload) => {
    return {
        type: FORGOT_PASSWORD_VERIFY_OTP,
        payload
    }
}

export const forgot_password_verify_otp_success = (payload) => {
    return {
        type: FORGOT_PASSWORD_VERIFY_OTP_SUCCESS,
        payload
    }
}

export const forgot_password_verify_otp_failed = (error) => {
    return {
        type: FORGOT_PASSWORD_VERIFY_OTP_FAILED,
        payload: error
    }
}

export const reset_password = (payload) => {
    return {
        type: RESET_PASSWORD,
        payload
    }
}

export const reset_password_success = (payload) => {
    return {
        type: RESET_PASSWORD_SUCCESS,
        payload
    }
}

export const reset_password_failed = (error) => {
    return {
        type: RESET_PASSWORD_FAILED,
        payload: error
    }
}

export const cancel_forgot_password = () => {
    return {
        type: CANCEL_FORGOT_PASSWORD,
    }
}